import React from 'react';
import BackButton from './backButton';

const SumpPumpsAndFrenchDrains = () => {
    return (
        <div className="container mx-auto p-4 pt-28">
            <h1 className="text-3xl font-semibold mb-4">Interior-Drainage: Sump Pumps and French Drains</h1>


            <BackButton />
            <p>
                Sump Pumps and French Drains are essential components to protect your property from water-related issues. Our expert services in Kitchener-Waterloo and the surrounding area ensure your peace of mind.
            </p>

            <p>
                Sump Pumps are automatic drainage pumps used to remove ground water seepage from sump pits and weeping tiles. They play a crucial role in preventing residential flooding. We offer a comprehensive line of professional-grade Primary Sump Pumps, Back-up Sump Pumps, Combination Sump Pumps, and Sump Pump Accessories.
            </p>

            <p>
                French Drains, on the other hand, are a highly effective way to manage water around your property. They can be installed either on the exterior or interior, and their primary purpose is to divert water away from your foundation, ensuring a dry and safe environment.
            </p>

            <div className="flex justify-center p-4">
                <div className="w-1/2 flex g-10">
                    <img src="/images/services/interior-drainage/sump-pump-4.gif" alt="Sump Pump" className="w-1/2 mx-auto rounded-lg shadow-lg" />
                    <img src="/images/services/interior-drainage/French Drain.webp" alt="French Drain" className="w-1/2 mx-auto rounded-lg shadow-lg" />
                </div>
            </div>

            <p>
                Whether you're in need of sump pump installation, replacement, or French drain solutions, we've got you covered. Contact us today for expert service in Kitchener-Waterloo and the surrounding area.
            </p>


        </div>
    );
};

export default SumpPumpsAndFrenchDrains;
